<template>
    <div class="simple-customer-result-mail">
        <div v-if="sapEqualsCeleraone">
            {{ login }}
        </div>
        <div
                v-if="!sapEqualsCeleraone"
        >
            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <div v-on="on" class="simple-customer-result-mail__different-mail-in-sap__mails">
                        <div
                            v-for="(m, index) in mail"
                            :key="`simple-customer-result-mail__different-mail-in-sap__mails-${index}`"
                        >
                            <b class="mr-1">{{m.label}}: </b><span>{{ m.mail }}</span>
                        </div>
                    </div>
                </template>
                <span>
                    <div
                        v-for="(d, index) in sapData"
                        :key="`simple-customer-result-mail__different-mail-in-sap__data-${index}`"
                        class="mb-1 mt-1"
                    >
                        SAP-Daten für {{ d.scope }}-GP {{ d.gpnumber }}: <br>
                        {{ d.data | sapDataToFullname }} <br>
                        Geb. am: {{ d.data | sapDataToBirthdate }} <br>
                        {{ d.data | sapDataToStreet }} <br>
                        {{ d.data | sapDataToCity }}
                    </div>
                </span>
            </v-tooltip>
        </div>
    </div>
</template>
<script>

export default {
    name: 'SimpleCustomerResultMail',
    props: [
        'sapData',
        'sapMail',
        'login',
        'ssoId',
    ],
    computed: {
        sapEqualsCeleraone() {
            return this.sapMail.every((sm => sm.mail.trim() === this.login.trim()));
        },
        mail() {
            return this.sapMail.map((sm) => {
                if (sm.scope === 'celeraone') {
                    return {
                        mail: sm.mail || '-',
                        label: 'C1',
                    };
                }
                return {
                    mail: sm.mail || '-',
                    label: `SAP ${sm.scope}`,
                };
            });
        },
    },
    methods: {
        afterUpdate(event) {
            this.$emit('afterUpdate', event);
        },
    },
};

</script>
<style scoped lang="scss">
    .simple-customer-result-mail__different-mail-in-sap__mails {
        display: table;
    }

    .simple-customer-result-mail__different-mail-in-sap__mails > div {
        display: table-row;
    }
    .simple-customer-result-mail__different-mail-in-sap__mails > div > * {
        display: table-cell;
        vertical-align: middle;
    }
    .simple-customer-result-mail__different-mail-in-sap__mails > div > *:first-child {
        padding-right: 8px;
    }

    .simple-customer-result-mail__different-mail-in-sap {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .simple-customer-result-mail__different-mail-in-sap > * {
        flex: 1;
    }

    .simple-customer-result-mail__different-mail-in-sap > *:last-child {
        flex: none;
    }
</style>
